.button {
    padding: 10px;
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
    background-color: white;
    margin-left: 6px;
    margin-right: 6px;
    display: flex;
}


.colorProceed {
    color: white;
    background-color: darkblue;
}

.buttonIcon {
    width: 1.5em;
    height: 1.5em;
    filter: invert(1);
    margin-inline-end: 4px;
}
